<div class="organization-modal">
  <ng-container>
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body body-modal">
      <form [formGroup]="myProjectScenarioConsumerForm">
        <div>
          <div class="sub-title">
            <h5 class="gray-font ml15">Transportation to consumer</h5>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  placeholder="Select transport"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex form-group checkBoxAlienMent">
                <div>
                  <input type="checkbox" class="chkOverview" />
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Custom truck</span>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="d-flex form-group">
                <div>
                  <button class="btn plus-button">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Add custom truck</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6" style="box-shadow: none !important; display: flex">
              <div class="form-group required" aria-required="true">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <label>Origin</label>
                  </div>
                </div>
                <div class="ng-autocomplete" style="box-shadow: none !important">
                  <ng-autocomplete> </ng-autocomplete>

                  <ng-template #itemTemplate let-item>
                    <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                  </ng-template>

                  <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>
                </div>
              </div>
              <div style="margin: 21px 15px">
                <!-- <span placement="top" tooltipClass="project-hint" 
                  ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)">
                  <a class="info-icon"><i class="fa fa-info-circle fa-lg originS"></i></a>
                </span> -->
                <span
                  placement="auto"
                  tooltipClass="sku-tooltip"
                  ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                >
                  <a class="info-icon">
                    <span>
                      <img
                        src="./assets/icons/question-mark-icon.svg"
                        width="16"
                        height="16" /></span
                  ></a>
                </span>
              </div>
            </div>
            <div class="col-sm-4 buttonrights">
              <button class="setOriginBtn">Set Origin</button>
            </div>
          </div>
        </div>
        <div>
          <div class="sub-title">
            <h5 class="gray-font ml15">Storage process</h5>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex form-group checkBoxAlienMent">
                <div>
                  <input type="checkbox" class="chkOverview" />
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Custom storage </span>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="d-flex form-group">
                <div>
                  <button class="btn plus-button">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Add custom storage</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  placeholder="Select Storage"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input type="text" maxlength="100" placeholder="Converter" />
                  <label>Storage days</label>
                </div>
              </div>
            </div>
            <div class="col-md-3 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input type="text" maxlength="100" placeholder="Converter" />
                  <label>Product loss (%)</label>
                </div>
              </div>
            </div>
            <div class="col-md-3 input-div">
              <div class="form-group required" aria-required="true">
                <div class="services-form">
                  <input type="text" maxlength="100" placeholder="Converter" />
                  <label>Cost of storage</label>
                </div>
              </div>
            </div>
            <div class="col-md-3 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  placeholder="Consumer location"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="sub-title">
            <h5 class="gray-font ml15">Product and package loss</h5>
          </div>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
              <div class="form-group required">
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  [items]="packageItems"
                  bindLabel="name"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  placeholder="Destination of product loss"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="sub-title">
            <h5 class="gray-font ml15">Storage process</h5>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="d-flex form-group checkBoxAlienMent">
                <div>
                  <input type="checkbox" class="chkOverview" />
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Custom end-of-life </span>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="d-flex form-group">
                <div>
                  <button class="btn plus-button">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
                <div>
                  <span style="color: black; margin-left: 15px">Add custom end-of-life</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button type="button" class="actionBTN btn btn-light cancel-btn modelBtn" (click)="onClose()">
        CANCEL
      </button>
      <button type="button" class="actionBTN modelBtn purpleBtnHoverEffect" (click)="onClose()">
        SAVE
      </button>
    </div>
  </ng-container>
</div>
